// extracted by mini-css-extract-plugin
export default {"button":"apps-popover_button__QOVcx"};